import { Component, Inject, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationsServiceInterface } from '../../../core/services/notifications/notifications-service.interface';
import { trackByFn } from '../../../core/helpers/trackby.function';

@Component({
  selector: 'gtd-notifications',
  templateUrl: './notifications.component.html',
})
export class NotificationsComponent implements OnDestroy {
  trackByFn = trackByFn;
  notifications$: Observable<any[]>;

  constructor(@Inject('NotificationsServiceInterface') private notificationsService: NotificationsServiceInterface) {
    this.notifications$ = this.notificationsService.notificationsObservable();
  }

  getNotificationTitle(type: string): string {
    switch (type) {
      case 'success':
        return 'Success.';
      case 'error':
        return 'Error.';
      case 'info':
        return 'Info.';
      default:
        return '';
    }
  }

  close(index) {
    this.notificationsService.remove(index);
  }

  ngOnDestroy(): void {
    this.notificationsService.unsubscribe();
  }
}
